export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/hand_drawn-pattern.c8dc692.svg";